import { fg } from '@atlassian/jira-feature-gating';

const PrivateGoalsInJiraRelayProvider = {
	get(): boolean {
		return fg('private_goals_in_jira');
	},
};

export default PrivateGoalsInJiraRelayProvider;
